import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

const HandleRedirectPage = () => {
  const { handle } = useParams();
  const navigate = useNavigate();
  
  // ✅ 1. Get the logged-in user's data from the ProfileContext
  const { user, linkedArtistAccounts, switchProfile, isLoading } = useProfile();

  useEffect(() => {
    // Don't run the logic until the profile context has loaded
    if (isLoading || !handle) return;

    const resolveHandle = async () => {
      const db = getFirestore();
      let foundProfile = null;

      // Query both collections to find the profile for the handle
      const usersQuery = query(collection(db, "users"), where("handle", "==", handle));
      const artistsQuery = query(collection(db, "artist_accounts"), where("handle", "==", handle));
      const [userSnapshot, artistSnapshot] = await Promise.all([getDocs(usersQuery), getDocs(artistsQuery)]);

      if (!userSnapshot.empty) {
        const doc = userSnapshot.docs[0];
        foundProfile = { id: doc.id, type: 'user', ...doc.data() };
      } else if (!artistSnapshot.empty) {
        const doc = artistSnapshot.docs[0];
        foundProfile = { id: doc.id, type: 'artist', ...doc.data() };
      }

      if (!foundProfile) {
        // Handle case where the handle doesn't exist
        navigate('/not-found', { replace: true }); // Or to an error page
        return;
      }
      
      // ✅ 2. Create a set of all profile IDs owned by the logged-in user
      const ownedProfileIds = new Set([
        user?.uid,
        ...linkedArtistAccounts.map(acc => acc.id)
      ]);

      // ✅ 3. Perform the ownership check
      if (ownedProfileIds.has(foundProfile.id)) {
        // The user owns this profile. Switch to it and go to the private dashboard.
        switchProfile(foundProfile);
        navigate('/profile', { replace: true });
      } else {
        // It's a public profile. Go to the public page.
        navigate(`/profile/${foundProfile.id}`, { replace: true });
      }
    };

    resolveHandle();
    
  }, [handle, isLoading, user, linkedArtistAccounts, switchProfile, navigate]);

  // Render a simple loading state while the redirect is processing
  return <p className="text-center mt-8">Resolving profile...</p>;
};

export default HandleRedirectPage;